import { render, staticRenderFns } from "./TeamChatIcon.vue?vue&type=template&id=2300ac92"
import script from "./TeamChatIcon.vue?vue&type=script&lang=js"
export * from "./TeamChatIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports